export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/loader_VA.0c3d0198.gif";